import { useEffect } from 'react';
import * as Sentry from '@sentry/browser';
import useStoreValues from '../use-store-values.js';
import { EntityResponseError } from '../entity-store.js';

/**
 * Initializes external services [Sentry, PostHog]
 * Listens for user/organizations/path changes to the store & calls external services
 */
export function useSentry(config) {
  const { currentUserHref, currentOrgHref } = useStoreValues(['currentUserHref', 'currentOrgHref']);

  // Initialize sentry on startup
  useEffect(() => {
    _initializeSentry(config);
  }, [config]);

  // Re-configure sentry scope when the current user or organization has changed
  useEffect(() => {
    Sentry.configureScope((scope) => {
      scope.setUser({ userId: currentUserHref, currentOrganizationId: currentOrgHref });
    });
  }, [currentUserHref, currentOrgHref]);
}

const _initializeSentry = (config) => {
  const sentryConfig = config && config.sentry;
  if (!sentryConfig) {
    return;
  }

  Sentry.init({
    dsn: sentryConfig.dsn,
    environment: sentryConfig.environment,
    beforeSend: function (event, hint) {
      const { originalException } = hint;
      if (originalException instanceof EntityResponseError) {
        if ([401, 403, 404, 422].includes(originalException.code)) {
          // Returning null drops the error entirely
          return null;
        }
      }

      if (event.exception.values.length > 0) {
        event.fingerprint = [
          String(originalException && originalException.message),
          String(event.exception.values[0].type),
          String(event.exception.values[0].type),
        ];
      }

      return event;
    },
  });
};
